import Vue from 'vue';

export default {
  LOCAL_ADD_WORK_INSTRUCTION_PACKAGE: (state, payload) => {
    state.workInstructionPackages.push(payload);
  },
  LOCAL_DELETE_WORK_INSTRUCTION_PACKAGE: (state, { packageId }) => {
    state.workInstructionPackages = state.workInstructionPackages.filter(
      (pkg) => pkg._id !== packageId
    );
    Vue.delete(state.workInstructionsByPackage, packageId);
    if (state.currentWorkInstructionPackage?._id === packageId) {
      state.currentWorkInstructionPackage = null;
    }
  },
  LOCAL_RENAME_WORK_INSTRUCTION_PACKAGE: (state, { packageId, title }) => {
    const wiPackage = state.workInstructionPackages.find(
      (pkg) => pkg._id === packageId
    );
    if (wiPackage) {
      Vue.set(wiPackage, 'title', title);
    }
    if (state.currentWorkInstructionPackage?._id === packageId) {
      Vue.set(state.currentWorkInstructionPackage, 'title', title);
    }
  },
  LOCAL_GET_WORK_INSTRUCTION_PACKAGES: (state, payload) => {
    state.workInstructionPackages = payload;
  },
  LOCAL_SET_CURRENT_WORK_INSTRUCTION_PACKAGE: (state, payload) => {
    state.currentWorkInstructionPackage = payload;
  },
  LOCAL_ADD_WORK_INSTRUCTION: (state, payload) => {
    const packageId =
      payload.packageId || state.currentWorkInstructionPackage?._id;
    if (!packageId) return;
    if (!state.workInstructionsByPackage[packageId]) {
      Vue.set(state.workInstructionsByPackage, packageId, []);
    }
    state.workInstructionsByPackage[packageId].push(payload);
  },
  LOCAL_UPDATE_WORK_INSTRUCTION: (state, payload) => {
    const packageId = state.currentWorkInstructionPackage?._id;
    const wiList = packageId
      ? state.workInstructionsByPackage[packageId] || []
      : [];
    const instructionIndex = wiList.findIndex((wi) => wi._id === payload._id);

    if (instructionIndex === -1) {
      return;
    }

    const currentInstruction = wiList[instructionIndex];
    wiList.splice(instructionIndex, 1, {
      ...currentInstruction,
      ...payload,
    });
  },
  LOCAL_DELETE_WORK_INSTRUCTION: (state, payload) => {
    const packageId = state.currentWorkInstructionPackage?._id;
    if (!packageId || !state.workInstructionsByPackage[packageId]) return;
    Vue.set(
      state.workInstructionsByPackage,
      packageId,
      state.workInstructionsByPackage[packageId].filter(
        (wi) => wi._id !== payload.instructionId
      )
    );
  },
  LOCAL_ADD_WORK_INSTRUCTION_STEP: (state, payload) => {
    const packageId = state.currentWorkInstructionPackage?._id;
    const wiList = packageId
      ? state.workInstructionsByPackage[packageId] || []
      : [];
    const instruction = wiList.find((wi) => wi._id === payload.instructionId);
    if (instruction) {
      if (instruction.steps === undefined) {
        Vue.set(instruction, 'steps', []);
      }
      instruction.steps.push(payload.step);
    }
  },
  LOCAL_UPDATE_WORK_INSTRUCTION_STEP: (state, payload) => {
    const packageId = state.currentWorkInstructionPackage?._id;
    const wiList = packageId
      ? state.workInstructionsByPackage[packageId] || []
      : [];
    const instruction = wiList.find((wi) => wi._id === payload.instructionId);

    if (!instruction || !instruction.steps) {
      return;
    }

    const stepIndex = instruction.steps.findIndex(
      (step) => step._id === payload.step._id
    );
    if (stepIndex === -1) {
      return;
    }

    instruction.steps.splice(stepIndex, 1, {
      ...instruction.steps[stepIndex],
      ...payload.step,
    });
  },
  LOCAL_DELETE_WORK_INSTRUCTION_STEP: (state, payload) => {
    const packageId = state.currentWorkInstructionPackage?._id;
    const wiList = packageId
      ? state.workInstructionsByPackage[packageId] || []
      : [];
    const instruction = wiList.find((wi) => wi._id === payload.instructionId);

    if (!instruction || !instruction.steps) {
      return;
    }

    instruction.steps = instruction.steps.filter(
      (step) => step._id !== payload.stepId
    );
  },

  LOCAL_SET_WORK_INSTRUCTION_PACKAGES: (state, payload) => {
    state.workInstructionPackages = payload;
  },

  LOCAL_SET_WORK_INSTRUCTIONS_FOR_PACKAGE: (
    state,
    { packageId, workInstructions }
  ) => {
    Vue.set(state.workInstructionsByPackage, packageId, workInstructions);
  },

  LOCAL_SET_ALL_WORK_INSTRUCTIONS_BY_PACKAGE: (state, payload) => {
    state.workInstructionsByPackage = payload;
  },

  LOCAL_SET_FILES_LINKED_TO_WORK_INSTRUCTION_STEP: (state, payload) => {
    const { instructionId, files, stepId } = payload;
    const packageId = state.currentWorkInstructionPackage?._id;
    const wiList = packageId
      ? state.workInstructionsByPackage[packageId] || []
      : [];
    const instruction = wiList.find((wi) => wi._id === instructionId);
    if (instruction && instruction.steps) {
      const step = instruction.steps.find((s) => s._id === stepId);
      if (step) {
        Vue.set(step, 'linkedDocuments', files);
      }
    }
  },

  LOCAL_SET_TASKS_TO_WORK_INSTRUCTION_STEP: (state, payload) => {
    const { instructionId, tasks, stepId } = payload;
    const packageId = state.currentWorkInstructionPackage?._id;
    const wiList = packageId
      ? state.workInstructionsByPackage[packageId] || []
      : [];
    const instruction = wiList.find((wi) => wi._id === instructionId);
    if (instruction && instruction.steps) {
      const step = instruction.steps.find((s) => s._id === stepId);
      if (step) {
        Vue.set(step, 'linkedTasks', tasks);
      }
    }
  },
  LOCAL_SET_FILES_LINKED_TO_WORK_INSTRUCTION: (
    state,
    { instructionId, files }
  ) => {
    const packageId = state.currentWorkInstructionPackage?._id;
    const wiList = packageId
      ? state.workInstructionsByPackage[packageId] || []
      : [];
    const instruction = wiList.find((wi) => wi._id === instructionId);
    if (instruction) {
      Vue.set(instruction, 'linkedDocuments', files);
    }
  },

  LOCAL_SET_TASKS_TO_WORK_INSTRUCTION: (state, { instructionId, tasks }) => {
    const packageId = state.currentWorkInstructionPackage?._id;
    const wiList = packageId
      ? state.workInstructionsByPackage[packageId] || []
      : [];
    const instruction = wiList.find((wi) => wi._id === instructionId);
    if (instruction) {
      Vue.set(instruction, 'linkedTasks', tasks);
    }
  },

  LOCAL_CHANGE_WORK_INSTRUCTIONS_ORDER: (state, payload) => {
    const { instructionId, targetInstructionId } = payload;
    const packageId = state.currentWorkInstructionPackage?._id;
    const workInstructions = packageId
      ? state.workInstructionsByPackage[packageId] || []
      : [];

    const fromIndex = workInstructions.findIndex(
      (wi) => wi._id === instructionId
    );
    const toIndex = workInstructions.findIndex(
      (wi) => wi._id === targetInstructionId
    );

    if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) {
      return;
    }

    const [movedInstruction] = workInstructions.splice(fromIndex, 1);
    workInstructions.splice(toIndex, 0, movedInstruction);
  },
  LOCAL_SET_WORK_INSTRUCTIONS_ORDER: (
    state,
    { packageId, workInstructions }
  ) => {
    Vue.set(state.workInstructionsByPackage, packageId, workInstructions);
  },
  LOCAL_CHANGE_WORK_INSTRUCTION_STEPS_ORDER: (state, payload) => {
    const { instructionId, stepId, targetStepId } = payload;
    const packageId = state.currentWorkInstructionPackage?._id;
    const wiList = packageId
      ? state.workInstructionsByPackage[packageId] || []
      : [];
    const instruction = wiList.find((wi) => wi._id === instructionId);

    if (!instruction || !instruction.steps) {
      return;
    }

    const fromIndex = instruction.steps.findIndex(
      (step) => step._id === stepId
    );
    const toIndex = instruction.steps.findIndex(
      (step) => step._id === targetStepId
    );

    if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) {
      return;
    }

    const [movedStep] = instruction.steps.splice(fromIndex, 1);
    instruction.steps.splice(toIndex, 0, movedStep);
  },

  LOCAL_SIGN_OFF_STEP: (
    state,
    { instruction, step, timestamp, userFullName, userId }
  ) => {
    const packageId = state.currentWorkInstructionPackage?._id;
    const wiList = packageId
      ? state.workInstructionsByPackage[packageId] || []
      : [];
    const stateInstruction = wiList.find((wi) => wi._id === instruction._id);

    const stateStep = stateInstruction.steps.find((s) => s._id === step._id);
    Vue.set(stateStep, 'signedAt', timestamp);
    Vue.set(stateStep, 'signedByFullName', userFullName);
    Vue.set(stateStep, 'signedBy', userId);
  },

  LOCAL_REOPEN_STEP: (state, { instruction, step }) => {
    const packageId = state.currentWorkInstructionPackage?._id;
    const wiList = packageId
      ? state.workInstructionsByPackage[packageId] || []
      : [];
    const stateInstruction = wiList.find((wi) => wi._id === instruction._id);
    if (!stateInstruction) return;
    const stateStep = stateInstruction.steps.find((s) => s._id === step._id);
    if (!stateStep) return;
    Vue.delete(stateStep, 'signedAt');
    Vue.delete(stateStep, 'signedByFullName');
    Vue.delete(stateStep, 'signedBy');
  },

  LOCAL_SET_JOB_WORK_INSTRUCTION_STATUS: (state, payload) => {
    state.jobWorkInstructionStatus = {
      ...state.jobWorkInstructionStatus,
      ...payload,
    };
  },

  LOCAL_ADD_COMMENT_TO_STEP: (state, { instructionId, stepId, comment }) => {
    const instruction = state.currentWorkInstruction.find(
      (wi) => wi._id === instructionId
    );
    if (!instruction || !instruction.steps) return;
    const step = instruction.steps.find((s) => s._id === stepId);
    if (!step) return;
    if (!step.comments) {
      Vue.set(step, 'comments', []);
    }
    step.comments.push(comment);
  },
};
